import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class BaseClientService {

  private apiServer: string;

  constructor(
    private http: HttpClient,
  ) {}

  get<T = any>(url: string, params?: any, endpoint?: string, responseType?: any | string): Observable<T> {

    this.apiServer = environment.backendUrl;

    if (endpoint) {
      this.apiServer = endpoint;
    }

    const fullUrl = this.apiServer + url;
    const headers = {};

   // params = {withCredentials:true}
    const {http} = this;

    return http.get<T>(fullUrl, {
      params,
      headers,
      responseType,
    });
  }

  getContato<T = any>(url: string, params?: any, endpoint?: string): Observable<T> {

    this.apiServer = environment.backendUrl;

    if (endpoint) {
      this.apiServer = endpoint;
    }

    const fullUrl = this.apiServer + url;
    const headers = {};

   // params = {withCredentials:true}
    const {http} = this;

    return http.get<T>(fullUrl, {
      params,
      headers,
    });
  }

  postFormData(url: string, formData: any) {
    this.apiServer = environment.backendUrl;
    const fullUrl = this.apiServer + url;
    const {http} = this;
    return http.post(fullUrl, formData);
  }

  post(url: string, body?: any, headers?: any, useFullUrl?: boolean): Observable<any> {
    this.apiServer = environment.backendUrl;
    const fullUrl = (!useFullUrl ? this.apiServer + url : url);
    if (!headers) {
      headers = {
        };
    }
    const {http} = this;
    return http.post(fullUrl, body, {headers});
  }

  delete(url: string, body?: any, headers?: any, useFullUrl?: boolean): Observable<any> {
    this.apiServer = environment.backendUrl;
    const fullUrl = (!useFullUrl ? this.apiServer + url : url);
    if (!headers) {
      headers = {
        };
    }
    const {http} = this;
    return http.delete(fullUrl, {headers});
  }

  put(url: string, body?: any, ttl?: number, endpoint?: string): Observable<any> {
    this.apiServer = environment.backendUrl;

    const fullUrl = this.apiServer + url;
    const headers = {
      'Content-Type': 'application/json',
    };

    const {http} = this;

    return http.put(fullUrl, body, {headers});
  }
}
